import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { Case } from '../../services/buildfire/rdb/cases';
import UnreadNotif from '../common/UnreadNotif';
import { doesCaseHaveUnreadMessage } from '../../util/case';
import GenericCaseListItem from '../case/CaseListItem';
import Badge from '../common/Badge';
import { useFirebase } from '../../services/firebase';
import useCaseIdParam from '../../hooks/useCaseIdParam';
import Typography from '../common/Typography';

const Timestamp = styled.div`
  display: flex;
  justify-content: center;
  font-size: 10px;
`;

interface CaseListItemProps {
  case: Case;
}

const BadgeContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
`;
const StyledUnreadNotif = styled(UnreadNotif)`
  line-height: 12px;
  margin-left: 6px;
`;
const BadgeContent = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const NewNotif: React.FC<{}> = () => {
  return (
    <BadgeContainer>
      <Badge fontColor="#163349" backgroundColor="#AECAE5">
        NEW
      </Badge>
    </BadgeContainer>
  );
};

const StatNotif: React.FC<{}> = () => {
  return (
    <BadgeContainer>
      <Badge
        fontColor="var(--ion-color-warning-contrast)"
        backgroundColor="var(--ion-color-warning)"
      >
        <BadgeContent>
          {/* <IonIcon icon={warning} style={{ height: '18px', width: '18px' }} /> */}
          <Typography style={{ textTransform: 'uppercase' }}>Stat</Typography>
        </BadgeContent>
      </Badge>
    </BadgeContainer>
  );
};

const CaseListItem: React.FC<CaseListItemProps> = ({ case: c }) => {
  const { currentUser, isAdmin } = useFirebase();
  const isUnread = doesCaseHaveUnreadMessage(c, currentUser!, isAdmin);
  const isNew = !c.viewedAt;
  const selectedCaseId = useCaseIdParam();
  return (
    <GenericCaseListItem
      case={c}
      rightHandContent={
        c.priority ? (
          <StatNotif />
        ) : isNew ? (
          <NewNotif />
        ) : (
          <Timestamp>{moment(c.createdAt).format('MMM DD')}</Timestamp>
        )
      }
      currentUser={currentUser!}
      isUnread={isUnread}
      UnreadNotifComponent={StyledUnreadNotif}
      selected={c.id === selectedCaseId}
      assignedTo={c.acceptedBy}
      showAssignment
      isAdmin
    />
  );
};

export default CaseListItem;
